<template>
	<div
		v-if="loaded"
		class="col-sm-8 col-md-6 col-lg-4 mx-auto mt-5"
	>
		<div class="card">
			<div class="card-header bg-primary text-white">
				<div class="card-title h5 m-0">{{ $t('login') }}</div>
			</div>
			<div class="card-body">
				<div v-if="showError">
					<div class="alert alert-danger">{{$t("notifications.clientCertLoginError")}}</div>
					<div class="alert alert-danger" v-if="errorMessage">{{errorMessage}}</div>
					<router-link to="/login">{{$t("backToLogin")}}</router-link>
				</div>
				<div v-if="showEmail">
					<form :action="certLoginUrl" method="GET">
						<div class="mb-3 alert alert-warning">
							<i class="fas fa-exclamation-circle"></i>
							&nbsp;
							{{$t('notifications.certLoginRequiredEmail')}}
						</div>
						<div class="form-group">
							<label class="required">{{$t('email')}}</label>
							<input class="form-control" type="email" v-validate="'required|email'" name="email" :data-vv-as="$t('email')" />
							<span class="text-danger">{{errors.first("email")}}</span>
						</div>
						<button class="btn btn-primary" :title="$t('buttons.submit.tooltipText')">{{$t('buttons.submit.btnText')}}</button>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showEmail: false,
			showError: false,
			errorMessage: null,
			loaded: false
		};
	},
	computed: {
		certLoginUrl() {
			return this.$store.getters.baseUrl + '/certificate/login';
		}
	},
	async created() {
		if (this.$route.query.auth) {
			const userInfo = this.$route.query.auth;
			if (userInfo) {
                localStorage.setItem('user', userInfo);

                const user = JSON.parse(localStorage.getItem('user'))

                this.$store.commit('authenticateUser', user);
                this.$store.commit('updateUserRoles', user.roles);
                this.$store.commit('updateClaims', user.userClaims);

				await this.$store.dispatch('loadUserPolicies');
				await this.$store.dispatch('loadUserSettingsAsync');

				this.$router.push('/');
			}
		} else if (this.$route.query.error) {
			this.showError = true;
			if (this.$route.query.message) {
				this.errorMessage = this.$t(
					'notifications.' + this.$route.query.message
				);
			}
		} else if (this.$route.query.requireEmail) {
			this.showEmail = true;
		}

		this.loaded = true;
	}
};
</script>

<style>
</style>
